<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] {{ $t('contractor') }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <!-- <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED)"/> -->
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Code" class="col-4">{{ $t('code') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Code" v-model="header.Code" type="text" :placeholder="$t('code')"
                                        v-if="header" :class="{ 'p-invalid': submitted && !header.Code }"
                                        :disabled="mode != this.$FORM_MODE_CREATE"
                                        :readonly="mode != this.$FORM_MODE_CREATE" />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Code && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('code')) }}
                                    </small>
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Company_Name" class="col-4">{{ $t('company_contractor') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Company_Name" v-model="header.Company_Name" required="true" type="text"
                                        :placeholder="$t('company_contractor')" v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.Company_Name }"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || (header && header.Status == this.$APPROVAL_STATUS.APPROVED)" />
                                    <Skeleton v-else-if="!header" />
                                    <small
                                        v-if="header && !header.Company_Name && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('company_contractor')) }}
                                    </small>
                                </div>
                            </div>
                             <div class="field grid">
                                <label for="Adress" class="col-4">{{ $t('adress') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Adress" v-model="header.Adress" required="true" type="text"
                                        :placeholder="$t('adress')" v-if="header"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    <Skeleton v-else-if="!header" />
                                    <!-- <small v-if="header && !header.Adress && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('adress')) }}
                                    </small> -->
                                </div>
                            </div>

                            <!-- <div class="field grid">
                                <label for="Service_Type" class="col-4">{{ $t('service_type') }}
                                    <span style="color: red;">*</span>
                                </label>
                                <div class="col-8 md-8">
                                    <InputText name="Service_Type" v-model="header.Service_Type" required="true" type="text"
                                        :placeholder="$t('service_type')" v-if="header"
                                        :class="{ 'p-invalid': submitted && !header.Service_Type }"
                                        :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    <Skeleton v-else-if="!header" />
                                    <small v-if="header && !header.Service_Type && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('service_type')) }}
                                    </small>
                                </div>
                            </div> -->

                            <!-- <FormField :labelName="$t('location')" fieldName="Location_Code" v-model="header" labelClass="col-4" fieldClass="col-8" v-if="header">
                                <CustomSelect 
                                    class="p-inputtext-sm" 
                                    v-model="header.Location_Code" 
                                    :url="this.$API_URL + 'list/location_code'" 
                                    :minLength="0" 
                                    :params="{isAuth : true}" 
                                    v-if="header" 
                                    :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || (header && header.Status == this.$APPROVAL_STATUS.APPROVED)"
                                    :filter="true"
                                    />
                                <small v-if="header && !header.Location_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('location')) }}
                                </small>
                            </FormField> -->

                            <div class="field grid" v-if="mode == this.$FORM_MODE_EDIT">
                                <label for="Active" class="col-4">{{ $t('active') }}</label>
                                <div class="col-8 md-8">
                                    <Checkbox name="Active" v-model="header.Active" :binary="true" v-if="header"
                                        :disabled="true"
                                        />
                                    <Skeleton v-else-if="!header" />
                                </div>
                            </div>
                            
                            <FormField :labelName="$t('reason')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-8 md-8" v-if="header && (header.Status == this.$APPROVAL_STATUS.APPROVED || header.Reason != null) && (mode == this.$FORM_MODE_EDIT || mode == this.$FORM_MODE_DELETE)">
                                <InputText name="Reason" v-model="header.Reason" type="text" :placeholder="$t('reason')" 
                                v-if="header" 
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT && mode != this.$FORM_MODE_DELETE" v-on:blur="onBlur()"/>
                                <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.APPROVED)) && submitted"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                </small>
                            </FormField>
                        </div>

                        <div class="col-6">
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-8 md-8">
                                <InputText name="Status" v-model="header.Status" type="text" :placeholder="$t('status')" 
                                v-if="header" :disabled="true" v-on:blur="onBlur()"/>
                            </FormField>

                            <!-- <FormField :labelName="$t('logo_contractor')" :fileModels="header.files_data" v-if="header" labelClass="col-4" fieldClass="col-6">
                                <CustomFileUpload
                                    :fileModels="viewFiles"
                                    :multiple="true" 
                                    :showUploadButton="false" 
                                    :showCancelButton="false" 
                                    :customUpload="false" 
                                    @select="onFileSelect" 
                                    @remove="onFileRemove" 
                                    :viewOnly="true" 
                                    :showHeader="false"
                                    @download="onDownloadFile"
                                    />                                   
                            </FormField>
                        
                            <FormField :labelName="''" :fileModels="header.files_data" v-model="header" v-if="header" fieldClass="col-6" labelClass="col-4">
                                <CustomFileUpload 
                                :fileModels="header.files_data"
                                :multiple="true" 
                                :showUploadButton="false"
                                :showCancelButton="false" 
                                :customUpload="false" 
                                accept="image/*"
                                @select="onFileSelect($event, header)"
                                :disabled="!(this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT)"
                                @remove="onFileRemove($event, header)" />
                            </FormField> -->
                        </div>
                       
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('release_approval')">
                                    <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                        :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>  
                        
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
export default {
    name: "Editor",
    data() {
        return {
            indexName: "ContractorIndex",
            url: this.$API_URL + "contractor/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            detailLog : null,
            dataModelRelease: [],
            dataChangesLog:this.$dataChangesLog,
            dataRelease: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Name" },
                { field: "Level", header: "Level" },
                { field: "Validity", header: "Validity" },
                { field: "Status", header: "Status" }
            ],
            viewFiles : null,

        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.detailLog = self.header.DetailLog;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    if(self.header.Status == this.$APPROVAL_STATUS.APPROVED) self.header.Reason = null;

                    if(self.header.Logo_Contractor){
                            var attachment = this.header.Logo_Contractor.split(';');
                            self.viewFiles = [];
                            attachment.forEach(a => {
                                if (a != '') {
                                    var name = a.split("/").at(-1);
                                    var d = {
                                        name: name,
                                        // url: a,
                                        id: self.header.Id
                                    };

                                    self.viewFiles.push(d);
                                }
                            });
                        }
                })
                .catch(function (error) {
                    alert(error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;

            var data = new FormData();
                
                if(this.header.files_data != null)
                    for(var x=0; x < this.header.files_data.length;x++){
                        var file = this.header.files_data[x];
                        data.append("attachments.File", file, file.name);
                }
                data.append("Code", this.header.Code);
                data.append("Id", this.header.Id);
                data.append("Company_Name", this.header.Company_Name);
                if(this.header.Reason != null)
                    data.append("Reason", this.header.Reason);
                //data.append("Service_Type", this.header.Service_Type);
                data.append("Adress", this.header.Adress);
                data.append("mode", this.header.mode);
                // if(this.header.Location_Code != null)
                //     data.append("Location_Code", this.header.Location_Code);
                this.$axios.post(this.url, data,{
                    headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                })
                .then((response) => {
                    if (response.data.success) {
                        if(self.header.mode == self.$FORM_MODE_CREATE || self.header.mode == self.$FORM_MODE_DRAFT)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Contractor " + self.header.Code + " has been Create successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_EDIT || self.header.mode == self.$FORM_MODE_DRAFT)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Contractor " + self.header.Code + " has been Edit successfully", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_DELETE)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Contractor " + self.header.Code + " has been Delete successfully", life: 3000 } });
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.$router.push({ path: "/Contractor/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            var self = this;
            //|| !this.header.Service_Type 

            if(this.mode != this.$FORM_MODE_DELETE){
                if (!this.header.Company_Name || !this.header.Code || (this.header.Status == this.$APPROVAL_STATUS.APPROVED && !this.header.Reason)) 
                {
                    return;
                }
            }else{
                if ((this.header.Status == this.$APPROVAL_STATUS.APPROVED && !this.header.Reason)) 
                {
                    return;
                }
            }
            // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
            //     self.showError("Error", "Must have attachment")
            //     return;
            // }   
            
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            var self = this;
            //|| !this.header.Service_Type 
            if (!this.header.Company_Name || !this.header.Code || !this.header.Adress) {
                return;
            }
            // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
            //     self.showError("Error", "Must have attachment")
            //     return;
            // }   

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                            this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Details.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.Details[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Details.splice(this.header.Details.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.Details) {
                let mode = this.header.Details[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
                data.files_data = [];
                for(var i = 0; i<event.files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        onDownloadFile(file){
            var self = this;
            this.$axios.get(this.url + "download_attachment/" + file.id + "/" + file.name, {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.name);
                    document.body.appendChild(link);
                    link.click();
                    
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    //self.showAssignModal = false;
                });
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    }
}
</script>